/*
  Grid view buttons on the collection page (canvasbynumbers.es).
  Mobile: one or two kits per row. Desktop: larger images or more kits at once.
  The choice lasts while the shopper stays on the collection page (filters,
  sorting and "load more" keep it); it is not saved anywhere.
  Buttons: sections/template-collection.liquid. Styles: assets/cbn-collection.css.
*/
(function () {
  if (window.cbnCollectionViewInit) { return; }
  window.cbnCollectionViewInit = true;

  var state = { mobile: 'grid', desktop: 'grid' };

  function device() {
    return window.matchMedia('(min-width: 992px)').matches ? 'desktop' : 'mobile';
  }

  function setCols(list, breakpoints, count) {
    breakpoints.forEach(function (bp) {
      var prefix = bp ? 'row-cols-' + bp + '-' : 'row-cols-';
      for (var i = 1; i <= 6; i++) { list.classList.remove(prefix + i); }
      list.classList.add(prefix + count);
    });
  }

  function apply() {
    var list = document.querySelector('.collection .product-list.row');
    if (list) {
      if (!list.hasAttribute('data-cbn-orig')) {
        list.setAttribute('data-cbn-orig', list.className);
      }
      list.className = list.getAttribute('data-cbn-orig');
      var current = device();
      var view = state[current];
      var one = current === 'mobile' && view === 'one';
      var dense = current === 'desktop' && view === 'dense';
      if (one) {
        setCols(list, ['', 'sm'], 1);
        setCols(list, ['md'], 2);
      }
      if (dense) {
        setCols(list, ['lg'], 4);
        setCols(list, ['xl', 'xxl'], 5);
      }
      list.classList.toggle('cbn-one', one);
      list.classList.toggle('cbn-dense', dense);
    }
    document.querySelectorAll('.cbn-view-switch').forEach(function (group) {
      var key = group.getAttribute('data-device') === 'desktop' ? 'desktop' : 'mobile';
      group.querySelectorAll('.cbn-view-btn').forEach(function (btn) {
        var active = btn.getAttribute('data-view') === state[key];
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.cbn-view-btn') : null;
    if (!btn) { return; }
    var group = btn.closest('.cbn-view-switch');
    var key = group && group.getAttribute('data-device') === 'desktop' ? 'desktop' : 'mobile';
    state[key] = btn.getAttribute('data-view');
    apply();
  });

  window.addEventListener('resize', apply);
  window.addEventListener('updated.ecomify.collection', function () {
    setTimeout(apply, 50);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
